<template>
  <div v-html="termsText"></div>
</template>
<script>
export default {
  data() {
    return {
      termsText: "",
    };
  },
  computed: {
    ssoSDK: function () {
      return this.$store.state.appData.ssoSDK;
    },
  },
  watch: {
    ssoSDK: {
      handler(o, n) {
        if (this.ssoSDK) {
          oauthSDK
            .getTerms({bsCode:this.$router.history.current.query.bsCode})
            .then((res) => {
              this.termsText = res;
            })
            .catch((err) => {
              console.log(err);
              this.defalutToast(err.message);
            });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
};
</script>